export function followUpIsNow(
  followupAt: string | undefined,
  resolvedAt: string | undefined
) {
  return followupAt && !resolvedAt
    ? new Date(followupAt).getTime() < new Date().getTime()
    : false;
}
